// extracted by mini-css-extract-plugin
module.exports = {"mail-to":"mail-to--3DNTX","mailTo":"mail-to--3DNTX","icon-clip":"icon-clip--2-5k1","iconClip":"icon-clip--2-5k1"};